module.exports = __webpack_public_path__ + "assets/img/btn.f4d630ae.png";